import { render, staticRenderFns } from "./RemoveDialog.vue?vue&type=template&id=6c4ec75e&"
import script from "./RemoveDialog.vue?vue&type=script&lang=js&"
export * from "./RemoveDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports